var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Type=alert-triangle, Size=24, Color=Black",
    clipPath: "url(#clip0_689_46715)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 15V15.01M12 9V11V9Z",
    stroke: "#1C1C1C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.00019 19H19.0002C19.3265 18.9977 19.6473 18.9156 19.9346 18.7609C20.2219 18.6061 20.4669 18.3834 20.6484 18.1122C20.8299 17.841 20.9422 17.5295 20.9756 17.2049C21.0091 16.8803 20.9626 16.5525 20.8402 16.25L13.7402 4C13.5672 3.6874 13.3137 3.42683 13.0059 3.24539C12.6982 3.06394 12.3474 2.96825 11.9902 2.96825C11.6329 2.96825 11.2822 3.06394 10.9744 3.24539C10.6667 3.42683 10.4131 3.6874 10.2402 4L3.14019 16.25C3.02013 16.5456 2.97252 16.8656 3.00134 17.1833C3.03016 17.501 3.13456 17.8073 3.30584 18.0764C3.47712 18.3456 3.7103 18.5698 3.98592 18.7305C4.26153 18.8912 4.57158 18.9836 4.89019 19",
    stroke: "#1C1C1C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_689_46715"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertTriangle);
export default __webpack_public_path__ + "static/media/alert-triangle.bd4fb51df24b1a3128e0a42d62c85f21.svg";
export { ForwardRef as ReactComponent };